import RfiActivityMessages from './RfiActivityMessages.component';

export default RfiActivityMessages;
